// @ts-check
import Text from 'components/base/Text';
import * as LighthouseService from 'common/services/lighthouse.service';
import { Tooltip } from '@material-ui/core';
import useAccountType from 'views/root/views/home/hooks/useAccountType';
import { LBButton, LBHelpIcon, LBReplaceSwitchIcon } from '@linearb/buzz';

const GroupWidgetHeader = ({
  name,
  articleId,
  isCustomizeMetrics,
  onClick
}) => {
  const { isUserViewer } = useAccountType();

  return (
    <div className='grid grid-cols-2 px-4 py-2'>
      <div className='capitalize text-[1.4rem] flex items-center'>{name}</div>

      <div className='flex justify-end'>
        {articleId && (
          <LBButton
            variant='ghost'
            size='icon'
            onClick={() => LighthouseService.navigateArticle(articleId)}
          >
            <LBHelpIcon />
          </LBButton>
        )}

        {isCustomizeMetrics && !isUserViewer && (
          <Tooltip
            title={
              <Text color='shark' data-testid='customize-tooltip'>
                Switch metric
              </Text>
            }
          >
            <LBButton onClick={onClick} variant='ghost' size='icon'>
              <LBReplaceSwitchIcon data-testid='edit-metric-icon' />
            </LBButton>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default GroupWidgetHeader;
